<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="bg-gray-200">
    <div class="container-wrap py-12">
      <h2 class="text-h1 mb-6">{{ title }}</h2>
      <p class="mb-6 min-h-[64px]" v-html="provideSanitized(description)" />
      <TheButton
        v-if="buttonName && buttonUrl"
        :id="buttonId"
        :to="buttonUrl"
        :title="buttonName"
        class="w-[180px]"
        @click="$emit('click-callback')"
      >
        <span class="text-sm">{{ buttonName }}</span>
      </TheButton>
    </div>
  </section>
</template>

<script setup lang="ts">
  interface IProps {
    title: string;
    description: string;
    buttonName?: string;
    buttonUrl?: string;
    buttonId?: string;
  }

  withDefaults(defineProps<IProps>(), {
    title: '',
    description: '',
    buttonName: '',
    buttonUrl: undefined,
    buttonId: undefined,
  });

  defineEmits<{ (e: 'click-callback'): void }>();
</script>
